import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import { Container } from "reactstrap";
import { AiOutlineCloseCircle } from "react-icons/ai";
import CategoryForm from "./CategoryAddForm";

function Modal(props) {
  return (
    <Transition.Root show={props.isModalShow} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[9999]"
        // initialFocus={cancelButtonRef}
        onClose={() => {}}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <Container
          className="fixed inset-0 z-10 overflow-y-auto mt-10"
          // onClick={onClose}
        >
          <div className="flex items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <Container className="flex justify-between items-center">
                  <p className="ml-5 text-lg font-semibold">Add Category</p>
                  <Dialog.Title
                    as="button"
                    onClick={props.onClose}
                    className="text-lg font-medium leading-6 text-gray-900 text-right p-5 outline-none"
                  >
                    <AiOutlineCloseCircle />
                  </Dialog.Title>
                </Container>
                <CategoryForm
                  data={props.data}
                  handleDrop={props.handleDrop}
                  handleDragOver={props.handleDragOver}
                  handleSubmit={props.handleSubmit}
                  handleChange={props.handleChange}
                  handleFileSelect={props.handleFileSelect}
                  handleRemoveImage={props.handleRemoveImage}
                  selectedImages={props.selectedImages}
                />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Container>
      </Dialog>
    </Transition.Root>
  );
}

export default Modal;
